import { stockholmPages } from "./stockholm";
import { göteborgPages } from "./goteborg";
import { sollentunaPages } from "./sollentuna";
import { huddingePages } from "./huddinge";
import { solnaPages } from "./solna";
import { marstaPages } from "./marsta";
import { sundbybergPages } from "./sundbyberg";
import { jarfallaPages } from "./jarfalla";
import { tabyPages } from "./taby";
import { danderydPages } from "./danderyd";
import { lidingoPages } from "./lidingo";
import { nackaPages } from "./nacka";
import { tyresoPages } from "./tyreso";
import { molndalPages } from "./molndal";
import { frolundaPages } from "./frolunda";
import { partillePages } from "./partille";
import { kungalvPages } from "./kungalv";
import { kungsbackaPages } from "./kungsbacka";
import { majornaPages } from "./majorna";
import { hisingenPages } from "./hisingen";
import { angeredPages } from "./angered";
import { lerumPages } from "./lerum";
import { tommaDodsboOrterPages } from "./tomma-dodsbo-orter";
import { bortforslingMoblerOrterPages } from "./bortforsling-mobler-orter";
import { flytthjalpOrtPages } from "./flytthjalp";

export const allCityPages = [
  ...stockholmPages,
  ...göteborgPages,
  ...sollentunaPages,
  ...huddingePages,
  ...solnaPages,
  ...marstaPages,
  ...sundbybergPages,
  ...jarfallaPages,
  ...tabyPages,
  ...danderydPages,
  ...lidingoPages,
  ...nackaPages,
  ...tyresoPages,
  ...molndalPages,
  ...frolundaPages,
  ...partillePages,
  ...kungalvPages,
  ...kungsbackaPages,
  ...majornaPages,
  ...hisingenPages,
  ...angeredPages,
  ...lerumPages,
  ...tommaDodsboOrterPages,
  ...bortforslingMoblerOrterPages,
  ...flytthjalpOrtPages,
];
